export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  delete: {
    cursor: 'pointer',
  },
};
